export const SummaryMetricIds = [
  'sales',
  'newCustomerSales',
  'netSales',
  'rcRevenue',
  'paymentGateways',
  'grossSales',
  'cogsOrders',
  'cogsRefunds',
  'cogs',
  'handlingFees',
  'customSpends',
  'totalCustomAdSpends',
  'totalCustomNonAdSpends',
  'inventoryItems',
  'inventoryItemsMissing',
  'totalInventoryCost',
  'totalInventoryValue',
  'shopifyAov',
  'shopifyAovIncludeZero',
  'shopifyCpa',
  'aov',
  'facebookAds',
  'googleAds',
  'googleAllCpa', // There was a reverse between googleCpa/googleAllCpa. Its too complex to fix since it requires reimport for all the shops so I just reverse here.
  'googleBounceRate',
  'googleConversionValue',
  'snapchatAds',
  'snapchatRoas',
  'snapchatImpressions',
  'snapchatSwipes',
  'snapchatCpm',
  'snapchatCpa',
  'snapchatConversionValue',
  'snapchatConversionPurchases',
  'googleConversionRate',
  'googleSessions',
  'shopifyOrders',
  'shopifyOrdersWithAmount',
  'totalNetProfit',
  'cashTurnover',
  'totalNetMargin',
  'totalCpa',
  'googleRps',
  'totalRefunds',
  'facebookRoas',
  'googleRoas',
  'totalGoogleAdsCtr',
  'totalGoogleAdsCpm',
  'googleCpc',
  'totalGoogleAdsClicks',
  'totalGoogleAdsImpressions',
  'ga_transactions_adGroup',
  'ga_all_transactions_adGroup',
  'ga_all_transactionsRevenue_adGroup',
  'ga_all_transactions_adGroup',
  'totalAllRoas',
  'googleCpa', // There was a reverse between googleCpa/googleAllCpa. Its too complex to fix since it requires reimport for all the shops so I just reverse here.
  'facebookCpc',
  'facebookCpm',
  'facebookCtr',
  'facebookCpoc',
  'facebookConversionValue',
  'facebookRevenuePerClick',
  'facebookCpa',
  'facebookViewThrough',
  'facebookViewThroughRoas',
  'facebookViewThroughCpa',
  'facebookPurchases',
  'facebookWebPurchases',
  'facebookMetaPurchases',
  'facebookWebConversionValue',
  'facebookMetaConversionValue',
  'newCustomersCpa',
  'klaviyoSalesPercent',
  'klaviyoFlowsSalesPercent',
  'klaviyoCampaignsSalesPercent',
  'klaviyoEmailOpenRate',
  'klaviyoUnsubscribed',
  'klaviyoPlacedOrderTotalPriceFlows',
  'klaviyoPlacedOrderTotalPriceFlowsPercent',
  'klaviyoPlacedOrderTotalPriceCampaigns',
  'klaviyoPlacedOrderTotalPriceCampaignsPercent',
  'klaviyoNewSubscribed',
  'klaviyoEmailsClicked',
  'klaviyoReceivedEmail',
  'klaviyoSmsClicked',
  'klaviyoCVR',
  'klaviyoRevenuePerEmail',
  'klaviyoNetNewSubscribers',
  'klaviyoPlacedOrderSales',
  'attentivePlacedOrderSales',
  'totalAttentivePlacedOrder',
  'tiktokAds',
  'tiktokRoas',
  'tiktokImpressions',
  'tiktokCpm',
  'tiktokCpc',
  'tiktokCtr',
  'tiktokCpa',
  'tiktokConversionValue',
  'tiktokPurchases',
  'uniqueCustomerSales',
  'customerFrequency',
  'ltvCpa',
  'mer',
  'totalReturns',
  'orders',
  'taxes',
  'newCustomersPercent',
  'oldCustomersPercent',
  'newCustomersOrders',
  'uniqueCustomers',
  'shipping',
  'discounts',
  'googleAnalyticsUsers',
  'gorgiasTotalTicketsCreated',
  'gorgiasTotalTicketsReplied',
  'gorgiasAverageResponseTime',
  'gorgiasAverageResolutionTime',
  'totalVariantsSold',
  'blendedAds',
  'roas',
  'newCustomersRoas',
  'blendedAttributedRoas',
  'poas',
  'pinterestAds',
  'pinterestRoas',
  'pinterestCpc',
  'pinterestCpm',
  'pinterestConversionValue',
  'pinterestPurchases',
  'pinterestImpressions',
  'pinterestCtr',
  'blendedSales',

  // benchmarks
  'benchmarksCPM',
  'benchmarksCPC',
  'benchmarksCTR',
  'benchmarksNCROAS',
  'benchmarksNCPA',
  'benchmarksBlendedROAS',
  'benchmarksTotalSpendAvg',
  'benchmarksNewCustomersAvg',
  'benchmarksSize',
  'benchmarksOrdersAvg',
  'benchmarksNewCustomersTotalPriceAvg',
  'benchmarksBlendedSpendAvg',
  'benchmarksFBAdsSpendAvg',
  'benchmarksFBAdsImpressionsAvg',
  'benchmarksFBAdsClicksAvg',
  'benchmarksFacebookRoas',
  'benchmarksGoogleRoas',

  // benchmarks new version
  'totalBenchmarksCPCGoogle',
  'totalBenchmarksCPMGoogle',
  'totalBenchmarksCTRGoogle',

  'totalBenchmarksGoogleAdsSpendAvg',
  'totalBenchmarksCTRTiktok',
  'totalBenchmarksCPCTiktok',
  'benchmarksTiktokRoas',
  'totalBenchmarksTiktokAdsSpendAvg',
  'totalBenchmarksBlendedCTR',
  'totalBenchmarksBlendedCpc',

  // attentive
  'attentiveNewSubscribed',
  'attentiveNetNewsubscribers',
  'attentiveUnsubscribed',
  'attentiveSalesPercent',
  'attentivePlacedOrderTotalPriceFlows',
  'attentivePlacedOrderTotalPriceFlowsPercent',
  'attentivePlacedOrderTotalPriceCampaigns',
  'attentivePlacedOrderTotalPriceCampaignsPercent',

  // enquirelabs
  'totalFacebookEnq',
  'totalGoogleEnq',
  'totalSnapchatEnq',
  'totalTiktokEnq',
  'totalPinterestEnq',
  'totalInstagramEnq',
  'responsesPrecent',

  // kno
  'totalFacebookKno',
  'totalGoogleKno',
  'totalSnapchatKno',
  'totalTiktokKno',
  'totalPinterestKno',
  'totalInstagramKno',
  'responsesPrecentKno',

  // social
  'facebookLikes',
  'facebookComments',
  'facebookShares',
  'facebookPosts',
  'facebookFollowers',
  'facebookSocialImpressions',
  'facebookSocialAvg',
  'facebookReach',
  'facebookProfileView',
  'facebookWebsiteClicks',
  'instagramLikes',
  'instagramComments',
  'instagramShares',
  'instagramPosts',
  'instagramFollowers',
  'instagramImpressions',
  'instagramAvg',
  'instagramAvgImpressionsFollowers',
  'instagramReach',
  'instagramProfileView',
  'instagramWebsiteClicks',

  //influencers
  'influencerConversionValue',
  'influencerPurchases',
  'influencerSpend',
  'influencerRoas',
  'influencerNcConversionValue',
  'influencerNcPurchases',

  //amazon-sales
  'amazonSales',
  'amazonProductItemPrice',
  'amazonSalesTaxes',
  'amazonOrders',
  'amazonItems',
  'amazonFees',
  'amazonSalesAFN',
  'amazonProductItemPriceAFN',
  'amazonSalesTaxesAFN',
  'amazonOrdersAFN',
  'amazonItemsAFN',
  'amazonFeesAFN',
  'amazonSalesMFN',
  'amazonProductItemPriceMFN',
  'amazonSalesTaxesMFN',
  'amazonOrdersMFN',
  'amazonItemsMFN',
  'amazonFeesMFN',

  'canceledAmazonSales',
  'canceledAmazonProductItemPrice',
  'canceledAmazonSalesTaxes',
  'canceledAmazonOrders',
  'canceledAmazonItems',
  'canceledAmazonFees',
  'canceledAmazonSalesAFN',
  'canceledAmazonProductItemPriceAFN',
  'canceledAmazonSalesTaxesAFN',
  'canceledAmazonOrdersAFN',
  'canceledAmazonItemsAFN',
  'canceledAmazonFeesAFN',
  'canceledAmazonSalesMFN',
  'canceledAmazonProductItemPriceMFN',
  'canceledAmazonSalesTaxesMFN',
  'canceledAmazonOrdersMFN',
  'canceledAmazonItemsMFN',
  'canceledAmazonFeesMFN',

  // amazon-ads
  'amazonAds',
  'amazonROAS',
  'amazonCPC',
  'amazonClicks',
  'amazonPurchases',
  'amazonTACos',
  'amazonAdsConversionValue',

  // amazon-ads
  'amazonNetSales',
  'amazonNetProfit',
  // 'amazonROAS',
  'amazonMER',
  'amazonAOV',
  'amazonCPA',
  'amazonExpenses',
  // pixel
  'pixelUniqueVisitors',
  'pixelVisitors',
  'pixelUniqueAtc',
  'pixelUniqueSessionsAtc',
  'pixelPurchases',
  'pixelConversionRate',
  'pixelAvgPagesPerSession',
  'pixelAvgSessionDuration',
  'pixelBounceRate',
  'pixelNewVisitors',
  'pixelPercentNewVisitors',
  'pixelPercentAtc',
  'pixelCostPerAtc',
  'pixelCostPerSession',

  //twitter-ads
  'twitterAds',
  'twitterClicks',
  // 'twitterSpend',
  'twitterConversionValue',
  'twitterPurchases',
  'twitterImpressions',
  'twitterEngagements',
  // twitterPurchases,
  'twitterCpm',
  'twitterFollows',
  'twitterCpa',
  'twitterRoas',

  // bing
  'bingAdSpend',
  'bingConversions',
  'bingConversionValue',
  'bingClicks',
  'bingImpressions',
  'bingRoas',
  'bingCtr',
  'bingCpa',
  'bingCpm',

  //recharge
  'rechargeSubscription1stOrderSales',
  'rechargeSubscriptionRecurringOrder',
  'rechargeTotalSubscriptionSales',
  'rechargeSubscriptionSalesPercentage',
  'rechargeTotalNewSubscriptions',
  'rechargeTotalCancelledSubscriptions',
  'rechargeTotalChurnedSubscribers',
  'rechargeTotalActiveSubscriptions',
  'rechargeTotalActiveSubscribers',
  'rechargeAverageActiveDays',
  'rechargeAverageSubscriptionsPerCustomer',
  'rechargeReactivatedSubscribers',

  //stripe

  'stripeSubscriptionUpgradeCount',
  'stripeSubscriptionUpgradeAmount',
  'stripeSubscriptionDowngradeCount',
  'stripeSubscriptionDowngradeAmount',
  'stripeSubscriptionDeletedCount',
  'stripeSubscriptionDeletedAmount',

  //MNTN
  'mountainSpend',
  'mountainRoas',
  'mountainImpressions',
  'mountainConversions',
  'mountainConversionRate',
  'mountainAverageOrderValue',
  'mountainCostPerAcquisition',
  'mountainCostPerVisit',
  'mountainConversionValue',

  //criteo
  'criteoSpend',
  'criteoRoas',
  'criteoDisplays',
  'criteoConversions',
  'criteoConversionRate',
  'criteoVisits',
  'criteoClicks',
  'criteoAverageOrderValue',
  'criteoCostPerAcquisition',
  'criteoCostPerVisit',
  'criteoConversionValue',

  //pacing
  'pacingTotalRevenue',
  'pacingReturningCustomersRevenue',
  'pacingNewCustomersRevenue',
  // 'pacingTotalNetProfit',
  'pacingBlendedAdSpend',
  'pacingFacebookAdsConversionValue',
  'pacingGoogleAdsConversionValue',
  'pacingSnapchatAdsConversionValue',
  'pacingTiktokAdsConversionValue',
  'pacingPinterestAdsConversionValue',

  //forwardView
  'forwardViewTotalRevenue',
  'forwardViewProductOrdersCount',
  'forwardViewNcCustomerCntAttribution',

  //shipstation
  'shipstationCost',
  'shipstationShipments',
  'shipstationOrders',
  'shipstationOrdersShipped',
  'shipstationOrdersUnshipped',
  'shipstationAvgCostPerShipment',
  'shipstationEstimation',

  //smsbump
  'smsbumpRevenue',
  'smsbumpCampaignRevenue',
  'smsbumpFlowRevenue',
  'smsbumpSpend',
  'smsbumpSent',
  'smsbumpUnsubscribed',
  'smsbumpConversions',
  'smsbumpAov',
  'smsbumpCtr',
  'smsbumpRoas',
  'smsbumpRoi',
  'smsbumpDelivered',
  'smsbumpClicks',

  //shipbob
  'shipbobOrders',
  'shipbobOrdersFulfilled',
  'shipbobPercentOfOrdersFulfilledOnTime',
  'shipbobFulfillmentCost',
  'shipbobAvgFulfillmentCost',
  'shipbobEstimation',

  //postscript
  'postscriptRevenue',
  'postscriptSent',
  'postscriptSubscribed',
  'postscriptUnsubscribed',
  'postscriptConversions',
  'postscriptDelivered',
  'postscriptAov',
  'postscriptCtr',
  'postscriptClicks',
] as const;
